const initialState = {
  list: [],
};

export default function documentsReducer(state = initialState) {
  return state;
}
